export const ENV = process.env.NODE_ENV;
export const PARTNER_API = process.env.VUE_APP_PARTNER_API;
export const COMMON_API = process.env.VUE_APP_COMMON_API;
export const REAL_ESTATE_API = process.env.VUE_APP_REAL_ESTATE_API;

// temp - until authentication working ...
export const ORGANIZATION_UUID = process.env.VUE_APP_ORG_UUID;
export const JSON_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const JSON_DATE_VINA_API_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
export const VINA_UI_DATE_FORMAT = "MM/dd/yyyy";
export const MAX_TRANS_ID = 999999999999999;
